import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import App from './app';
import { AuthenticationResult, EventType } from '@azure/msal-browser';
import { authServiceSingleton } from './services/authService';
import { markProgrammaticReload } from './services/analytics/pageLoad';

const msalInstance = await authServiceSingleton.getMsalInstance();

// Safari restores pages from bfcache (back/forward cache) without re-running JS.
// MSAL state and React context are stale in that snapshot, which causes a white page.
// Force a reload whenever the page is restored from bfcache.
globalThis.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    markProgrammaticReload('bfcache_restore');
    globalThis.location.reload();
  }
});

if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

msalInstance.addEventCallback((event) => {
  if (
    event.eventType === EventType.LOGIN_SUCCESS ||
    (event.eventType === EventType.SSO_SILENT_SUCCESS && event.payload)
  ) {
    const payload = event.payload as AuthenticationResult;
    msalInstance.setActiveAccount(payload.account);
  }
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </StrictMode>,
);
